import { FaSpinner } from 'react-icons/fa';
import ActionButton from '../ActionButton';

// ═══════════════════════════════════════════════════════════════
// INTERFACES & TYPES
// ═══════════════════════════════════════════════════════════════

interface BureauConfig {
    code: string;
    name: string;
}

interface BatchActionBarProps {
    selectedCount: number;
    isReprocessing: boolean;
    showReprocess: boolean;
    hasFilters: boolean;
    bureaus: BureauConfig[];
    onReprocess: () => void;
    onClearFilters: () => void;
    onViewAnalysis: () => void;
    onRefreshPaf: () => void;
    onContinueAnalysis: () => void;
    onRunSingleBureau: (bureauCode: string) => void;
}

// ═══════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════

export default function BatchActionBar({
    selectedCount,
    isReprocessing,
    showReprocess,
    hasFilters,
    bureaus,
    onReprocess,
    onClearFilters,
    onViewAnalysis,
    onRefreshPaf,
    onContinueAnalysis,
    onRunSingleBureau,
}: BatchActionBarProps) {
    return (
        <div className="flex gap-2">
            {showReprocess && (
                <ActionButton variant="warning" size="sm" disabled={isReprocessing} onClick={onReprocess}
                    icon={isReprocessing ? <FaSpinner className="animate-spin" /> : undefined}
                >
                    {isReprocessing ? 'Reprocessando...' : 'Reprocessar Lote'}
                </ActionButton>
            )}
            {hasFilters && (
                <ActionButton variant="secondary" size="sm" onClick={onClearFilters}>
                    Limpar filtros
                </ActionButton>
            )}
            <ActionButton variant="secondary" size="sm" onClick={onViewAnalysis}>
                Ver Análise
            </ActionButton>

            {selectedCount > 0 && (
                <>
                    <ActionButton variant="secondary" size="sm" onClick={onRefreshPaf}>
                        Atualizar PAF ({selectedCount})
                    </ActionButton>
                    <ActionButton variant="primary" size="sm" onClick={onContinueAnalysis}>
                        Continuar Análise ({selectedCount})
                    </ActionButton>
                    <select
                        onChange={(e) => {
                            const bureau = e.target.value;
                            if (!bureau) return;
                            e.target.value = '';
                            onRunSingleBureau(bureau);
                        }}
                        className="px-3 py-1.5 text-sm bg-gray-600 dark:bg-gray-500 text-white rounded hover:bg-gray-700 dark:hover:bg-gray-600 dark:border-slate-600"
                        defaultValue=""
                    >
                        <option value="">Rodar em Birô...</option>
                        {bureaus.map(b => (
                            <option key={b.code} value={b.code}>{b.name}</option>
                        ))}
                    </select>
                </>
            )}
        </div>
    );
}
